import React from "react";

import { faInfoCircle } from "@awesome.me/kit-4c83d50d0d/icons/classic/light";
import { faHourglassHalf } from "@awesome.me/kit-4c83d50d0d/icons/classic/regular";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cx from "classnames";

import { Tooltip } from "~/ui";

import styles from "./MeetingCost.module.css";

interface MeetingCostProps {
	wrapperStyles: CSSModuleClasses;
	isMonetary: boolean;
	meetingCostOccurrence: string;
	meetingCostSeries: string;
	numOccurrences: number;
	isInfinite: boolean;
}

export default function MeetingCost({
	wrapperStyles,
	meetingCostOccurrence,
	meetingCostSeries,
	numOccurrences,
	isMonetary,
	isInfinite,
}: MeetingCostProps) {
	const popupText = isMonetary
		? "Estimated cost based on attendees & time. Highlighted to inspire effective time use. No real employee data used."
		: "Calculated using the number of meeting attendees and the duration";

	return (
		<div className={wrapperStyles.infoRow}>
			<div className={cx(wrapperStyles.infoRow__icon, wrapperStyles.centeredOnFirstLine)}>
				<FontAwesomeIcon fixedWidth icon={faHourglassHalf} />
			</div>
			<div className={cx(wrapperStyles.infoRow__text, wrapperStyles.textSmall, wrapperStyles.secondaryText)}>
				Meeting Cost:&nbsp;
				<span className={cx({ [styles.isMonetary]: isMonetary })}>{meetingCostOccurrence}</span>
				<Tooltip key="meeting-cost-icon" className={styles.meetingCostIconTooltip} content={popupText} placement="top">
					<FontAwesomeIcon icon={faInfoCircle} className={styles.warningIcon} fixedWidth />
				</Tooltip>
				{numOccurrences > 1 && (
					<div className={wrapperStyles.seriesCostText}>
						{meetingCostSeries} {isInfinite ? "over the next 12 months" : "for the duration of the series"}
					</div>
				)}
			</div>
		</div>
	);
}
